import {default as http} from './HttpService'
import BaseService from "@/services/BaseService";

class ReportsService extends BaseService {
    constructor() {
        super()
    }

    getDataStock(filters) {
        return http.client.post('/v1/report/stock-closed-projection',filters);
    }
    getProtheusDataFiltered(filters) {
        return http.client.post('/v1/protheus/protheus-filters', filters);
    }
    getDataContracts(filters) {
        return http.client.post('/v1/protheus/get_contract', filters);
    }
    getContract(contract) {
        return http.client.post('v1/protheus/contractData',{contract:contract});
    }
    getVolumesN(company) {
        return http.client.post('/v1/protheus/total-volumen-max-min', {
            company_id: company
        });
    }
    getVolumesB(company) {
        return http.client.post('/v1/protheus/total-benefit-volumen-max-min', {
            company_id: company
        });
    }
    getQuebra(company) {
        return http.client.post('/v1/protheus/quebra-max-min', {
            company_id: company
        });
    }
    getSellersNames(company) {
        return http.client.post('/v1/protheus/contract-seller-name-id', {
            company_id: company
        });
    }
    getContractsNumbers(company) {
        return http.client.post('/v1/protheus/contract-name-id', {
            company_id: company
        });
    }
    getDataSellers(filters) {
        return http.client.post('/v1/protheus/protheus-sellers', filters)
    }
    getGeneralReport(data) {
        return http.client.post('/v1/reports/general-report', data, {
            responseType: 'blob'
        });
    }
    getBiorganicFiltered(filters, source) {
        return http.client.post('/v1/record/records-paginated-to-biorganic-report', filters, {
            cancelToken: source.token
        });
    }
    getTraceabilityFiltered(filters) {
        return http.client.post('/v1/record/records-traceability-paginated', filters);
    }
    getBiorganicReport(filters) {
        return http.client.post('/v1/reports/biorganic-report/excel', filters, {
            responseType: 'blob'
        });
    }
    getTraceabilityV2Report(filters, source) {
        return http.client.post('/v1/record/records-lots-report', filters, {
            cancelToken: source.token
        });
    }
    getExistingTraceabilityReport(filters) {
        return http.client.post('/v1/traceability_saved/get-saved', filters);
    }
    generateReportsByLotAndProduct(data) {
        return http.client.post('/v1/traceability_saved/save-list', data);
    }
    getDateNumberOfPendants() {
        return this.requestWithCancellation('get', '/v1/report/get-date-number-of-pendants', null, 'getDateNumberOfPendants');
    }
    setManualStockUpdate() {
        return http.client.get('/v1/report/manual-stock-update');
    }
    setDateToStartStockReset(data) {
        console.log(data)
        return http.client.post('/v1/report/configuration', data);
    }
    checkCanProcess() {
        return http.client.get('/v1/report/check-can-process');
    }
    getQrList(filters) {
        return http.client.post('/v1/traceability_saved/filter_pageable', filters);
    }
    activeOrDeactive(data) {
        return http.client.put('/v1/traceability_saved/change_active', data);
    }
    setPrintLimit(data) {
        return http.client.put('/v1/traceability_saved/set_print_limit', data);
    }
    getStockDate() {
        return http.client.get('/v1/report/configuration-get-date');
    }
    deleteTraceabilityReport(id) {
        return http.client.delete(`/v1/traceability_saved/${id}`);
    }
    getCustomReportsList(data) {
        return http.client.post(`/v1/custom-reports/paginated`, data);
    }
    generateCustomReport(data) {
        return http.client.post(`/v1/custom-reports`, data);
    }
    downloadCustomReport(id) {
        return http.client.get(`/v1/custom-reports/download-file/${id}`, {
            responseType: 'blob'
        });
    }

    // ===============================
    // WHATSAPP/EMAIL REPORT SHARING ENDPOINTS  
    // ===============================
    
    // 1. Lista de arquivos gerados de relatórios (files)
    getReportFilesPaginated(data) {
        console.log('ReportsService.getReportFilesPaginated called with:', data);
        return http.client.post('/v1/save_report_file/paginated', data);
    }

    // 2. Lista de tipos de relatórios  
    getReportTypes(params = {}) {
        // Usa el endpoint correcto para subtipos
        if (params.type) {
            return http.client.get(`/v1/report_configuration/available_sub_types/${encodeURIComponent(params.type)}`);
        }
        return http.client.get(`/v1/report_configuration/available_sub_types`);
    }

    // 3. Gerar e salvar arquivo de relatório (file)
    generateAndSaveReportFile(data) {
        return http.client.post('/v1/save_report_file', data);
    }

    // 4. Lista de operações de envio
    getSharedReportsPaginated(data) {
        console.log('ReportsService.getSharedReportsPaginated called with:', data);
        return http.client.post('/v1/shared_report/paginated', data);
    }

    // 5. Lista de destinatários por tipo de relatório
    getRecipientsByReportType(data) {
        console.log('ReportsService.getRecipientsByReportType called with:', data);
        return http.client.post('/v1/report_configuration/available_recipients', data);
    }

    // 6. Salvar solicitação de envio
    saveSharedReportRequest(data) {
        return http.client.post('/v1/shared_report', data);
    }

    // 7. Visualizar detalhes de uma operação de envio
    getSharedReportDetails(id) {
        console.log('ReportsService.getSharedReportDetails called with id:', id);
        return http.client.get(`/v1/shared_report/${id}`);
    }

    // 8. Reenviar reportes fallidos
    resendFailedReports(data) {
        console.log('ReportsService.resendFailedReports called with:', data);
        return http.client.post('/v1/shared_report/resend', data);
    }
    
    // 9. Download report file by ID
    downloadReportFile(id) {
        console.log('ReportsService.downloadReportFile called with id:', id);
        return http.client.get(`/v1/api/share-report/download/${id}`, {
            responseType: 'blob'
        });
    }
}

export default new ReportsService()
